import React, { useEffect } from "react";

const OVERLAY_MS = 3000;

export default function StoryCompletionOverlay({ onDone }) {
  useEffect(() => {
    const timeout = setTimeout(onDone, OVERLAY_MS);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div className="story-completion-overlay" data-testid="story-completion-overlay" role="status">
      <div className="story-completion-content">
        <span className="fa fa-check-circle" />
        <span className="joystix">Story complete!</span>
      </div>
    </div>
  );
}
